import i18n from 'i18next';

export const numbersToLocaleString = (value) => {
  try {
    if (value) {
      const val = localStringToNumbers(value);
      return Number(Number(val).toFixed(2))
        .toLocaleString(i18n.language, { maximumFractionDigits: 2, minimumFractionDigits: 2 });
    }
  } catch (e) {
    // eslint-disable-next-line no-console
    console.log('numbersToLocaleString Error', e.message);
    return value;
  }
};

export const localStringToNumbers = value => {
  try {
    if (value && Number.isNaN(Number(value))) {
      const regSep = i18n.language === 'nl' ? new RegExp(/\./g) : new RegExp(/,/g);
      const regDec = i18n.language === 'nl' ? new RegExp(/,/) : new RegExp(/\./);
      const serialize = String(value)
        .replace(regSep, '')
        .replace(regDec, '.');
      return Number(serialize);
    } else {
      return Number(value);
    }
  } catch (e) {
    // eslint-disable-next-line no-console
    console.log('numbersToLocaleString Error', e.message);
    return value;
  }
};